import { SUGGESTION_ACTIONS_QUERY_KEY } from "./const";
import type { SuggestionActionsQueryKeys } from "./types";

export const suggestionActionsQueryKeys: SuggestionActionsQueryKeys = {
    list: (): readonly string[] => [SUGGESTION_ACTIONS_QUERY_KEY],
};
